// extracted by mini-css-extract-plugin
export default {"wrap":"achieveMessage_wrap__9VNCh","p":"achieveMessage_p__TKhw-","pure":"achieveMessage_pure__0ObPV"};